import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=401b3676&scoped=true&"
var script = {}
import style0 from "./Footer.vue?vue&type=style&index=0&id=401b3676&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401b3676",
  null
  
)

export default component.exports